export default "__VITE_ASSET__BOLsUqB5__"